import httpManager from "@/app/shared/utils/httpManager";
/**
 * Obtener Plantillas de WhatsApp.
 *
 * @return {Promise<Array>} Lista de colas.
 */
export async function fetchEmailTemplates(withParameters = true, portfolio) {
  let url = `/channels/email-templates/?`;
  url += !withParameters ? `with_parameters=False` : '';
  if (portfolio) url += `portfolio=${portfolio}`;
  const response = await httpManager.get(url);
  return response?.data.results;
}
